import EmailTemplate from '../../components/templates/EmailTemplate';

function Email() {
  return <EmailTemplate />;
}
export default Email;
